import React from "react";
import {
  Box,
  useTheme,
  Card,
  CardContent,
  Typography,
  Button,
} from "@mui/material";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const ReleaseNots = () => {
  const theme = useTheme();
  const drawerWidth = 10;
  const collapsedWidth = 240;
  const { drawerOpen } = useOutletContext();
  const navigate = useNavigate();

  const releaseNotes = [
    "Store Format - Capital Expenses Plumbing and Visual Merchandising Store A and B table implemented",
    "Inventory and Online Distribution section note updated",
    "Save button skeleton loader added for Modules 6 to 10 and Assessments section month button set to static position",
    "Brand Journey 'Add Another' button style updated and Promotion Calendar date field removed",
    "Store Level Services note content updated and table alignment improved in Loyalty Program, Pricing Strategy, and Costs sections",
    "Note and field warning content updated in Category Management and Gross Margin module",
    "Upload image label alignment fixed and subtitle updated consistently",
    "All module stepper content updated",
  ];

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        marginTop: "35px",
        marginLeft: `${drawerOpen ? drawerWidth : collapsedWidth}px`,
        width: `calc(100% - ${drawerOpen ? drawerWidth : collapsedWidth}px)`,
        transition: theme.transitions.create(["margin-left", "width"], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      }}
    >
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
          p: 2,
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 800,
            borderRadius: 4,
            boxShadow: 4,
            p: 2,
          }}
        >
          <CardContent>
            {/* Header */}
            <Box textAlign="center" mb={3}>
              <Typography variant="h5" fontWeight={700} color="primary.main">
                Release Notes
              </Typography>

              <Typography variant="body2" color="text.secondary">
                RETAIL SIMULATION • 28-05-2026
              </Typography>
            </Box>

            {/* Description */}
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
              mb={3}
            >
              Check out the latest updates, improvements, and fixes made to the
              platform.
            </Typography>

            {/* Link */}
            <Box textAlign="center" mb={3}>
              <Link
                target="_blank"
                to="https://docs.google.com/document/d/1GFID5t0EGZJ20h6DnPpxISFeQ1VC5uI50N9-tvVtQXU/edit"
                style={{
                  textDecoration: "none",
                  fontWeight: 600,
                  color: "#1976d2",
                }}
              >
                View Detailed Release Notes →
              </Link>
            </Box>

            {/* Button */}
            <Box textAlign="center">
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                sx={{
                  borderRadius: "10px",
                  px: 4,
                  textTransform: "none",
                  fontWeight: 600,
                  backgroundColor: "#51b0cfff",
                  ":hover": { background: "#51b0cfff", color: "#fff" },
                }}
                onClick={() => {
                  navigate("/superAdmin/adminControls");
                  window.scrollTo({ top: 0, behavior: "auto" });
                }}
              >
                Continue
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default ReleaseNots;
